import { render, staticRenderFns } from "./TwoColumnQuizReviewLayout.vue?vue&type=template&id=9f5b9efc"
import script from "./TwoColumnQuizReviewLayout.vue?vue&type=script&lang=js"
export * from "./TwoColumnQuizReviewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports